import React, { useEffect, useRef, useState } from 'react'
import useEffectOnce from '../hooks/useEffectOnce';
import { useDispatch } from 'react-redux';
import { fetchOrgdata, fetchcoundata, fetchDocdata } from '../reduxactions/organizationactions/OrgProfileActions';
import { useSelector } from 'react-redux';
import { RootState } from '../reducers';
import { Message } from 'primereact/message';
import { UploadImageData, EditData, viewdata } from '../reduxactions/organizationactions/OrgProfileActions';
import { Toast } from 'primereact/toast';
import { FileUpload, FileUploadHandlerEvent } from 'primereact/fileupload';
import { Card } from 'primereact/card';
import { Panel } from 'primereact/panel';
import { InputText } from 'primereact/inputtext';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { useNavigate } from 'react-router-dom';
import { Calendar } from 'primereact/calendar';
import { InputTextarea } from 'primereact/inputtextarea';





var imageuser = require('../assets/images/images.png');




const OrganizationProfile = () => {
    //To get session values
    const uid = window.sessionStorage.getItem('uid');
    const usertype = window.sessionStorage.getItem('usertype');

    const dispatch = useDispatch()

    //For orgtype selection
    const orgtypeOptions = [
        { label: 'Charity', value: 'charity' },
        { label: 'Non_charity', value: 'non_charity' },
    ];
    //For suborgtype selection
    const suborgtypeOptions = [
        { label: 'Orphanage', value: 'orphanage' },
        { label: 'Oldagehome', value: 'oldagehome' },
        { label: 'Animals Charities', value: 'animal' },
        { label: 'Health Charity', value: 'health' },
        { label: 'Charity', value: 'charity' },
        { label: 'Education Charity', value: 'education' },
        { label: 'Environmental Charity', value: 'environment' },
    ];

    //To get profile data
    const fetchDataAsync = async () => {
        try {
            await dispatch(fetchOrgdata(uid) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    //To get countrydata
    const fetchcountrydata = async () => {
        try {
            await dispatch(fetchcoundata(uid) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    //To get Attacments data
    const fetchattachDataAsync = async () => {
        try {
            await dispatch(fetchDocdata(uid) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    //Calling data once
    useEffectOnce(() => {
        fetchcountrydata();
        fetchDataAsync();
        fetchattachDataAsync();
    }, [dispatch]);

    //Image Formats

    const data = useSelector((state: RootState) => state.orgpro.odata)
    const docdata = useSelector((state: RootState) => state.orgpro.docdata)
    const UploadManagerImage = async (event: FileUploadHandlerEvent) => {
        const files = event.files;
        if (files.length > 0) {
            const file = files[0];
            await dispatch(UploadImageData(file, uid) as any);
            toast.current.show({ severity: 'success', summary: 'Success', detail: imgdata, life: 3000 });
        } else {
        }
        fetchDataAsync()
        setTimeout(() => {
            window.location.reload();
        }, 3000);

    };

    const imgdata = useSelector((state: RootState) => state.orgpro.imgdata)
    let imgmessage = '';
    {
        imgdata !== '' && (
            imgmessage = "Profile photo updated successfully"
        )
    }
    const toast = useRef(imgdata);



    const countrydata = useSelector((state: RootState) => state.orgpro.countrydata)
    console.log("Countrydata:", countrydata)
    //To update Profile
    const [nameoforg, setOrgName] = useState('');
    const [nameofperson, setPersonName] = useState('');
    const [email, setEmail] = useState('');
    const [designation, setDesignation] = useState('');
    const [phone, setPhone] = useState<number | any>('');
    const [licenseno, setlicenseno] = useState('');
    const [ogrtype, setOrgtype] = useState<string>('');
    const [website, setWebsite] = useState('');
    const [address, setAddress] = useState('');
    const [city, setCity] = useState('');
    const [state, setstate] = useState('');
    const [country, setCountry] = useState('');
    const [pincode, setPincode] = useState('');

    const [licenseexpiry, setlicenseexpiry] = useState('');
    const [orgsubtype, setOrgsubtype] = useState<string>('');
    const [paypal, setPaypal] = useState('');
    const [resume, setResume] = useState('');


    useEffect(() => {
        if (data.length > 0) {
            setOrgName(data[0].nameoforg);
            setPersonName(data[0].nameofperson);
            setEmail(data[0].email);
            setDesignation(data[0].designation);
            setPhone(data[0].phone);
            setlicenseno(data[0].licenseno);
            setOrgtype(data[0].ogrtype);
            setWebsite(data[0].website);
            setAddress(data[0].address);
            setCity(data[0].city);
            setstate(data[0].state);
            setCountry(data[0].country);
            setPincode(data[0].pincode);
            setlicenseexpiry(data[0].licenseexpiry);
            setOrgsubtype(data[0].orgsubtype);
            setPaypal(data[0].paypal);
            setResume(data[0].resume);

        }

    }, [data]);

    const updatedata = useSelector((state: RootState) => state.orgpro.updatedata)
    //const toast1 = useRef(updatedata);

    useEffect(() => {
        if (updatedata && updatedata.length > 0) {
            toast.current.show({ severity: 'info', summary: 'info', detail: updatedata, life: 3000 })

        }

    }, [updatedata]);


    const Oprofile = async () => {
        try {
            await dispatch(EditData(nameoforg, nameofperson, email, designation, phone, licenseno, ogrtype, website, address, city, state, country, pincode, licenseexpiry, orgsubtype, paypal, resume, uid) as any);
        } catch (error) {
            console.log("error while updating profile", error)
        }
        fetchDataAsync()

        setTimeout(() => {
            window.location.reload();
        }, 3000);


    }


    const [globalFilter, setGlobalFilter] = useState('');


    const [acceptfield, setfield] = useState(false);
    const cancelfield = () => {
        setfield(false);
    }


    const viewupload = (rowData: any) => {
        console.log("RowData:", rowData)
        assignData.current = { did: rowData.DocID }

        setfield(true);
        fetchDataAsyncdialog()
    };
    const assignData = useRef({ did: '' })

    const fetchDataAsyncdialog = async () => {
        try {
            const { did } = assignData.current;
            console.log("DocID", did)
            await dispatch(viewdata(did) as any);
        } catch (error) {
            console.error('Error deleting data:', error);
        }
    }
    const dataview = useSelector((state: RootState) => state.orgpro.dataview)

    const navigate = useNavigate();

    const Donates = () => {
        const url = `/receiveddonations`;

        navigate(url);
    };

    const handlePhoneChange = (e: any) => {
        const inputPhone = e.target.value;
        // Using regex to keep only digits and limiting to 10 digits
        const formattedPhone = inputPhone.replace(/\D/g, '').slice(0, 10);
        setPhone(formattedPhone);
    };
    //for help
    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/orgprofile.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
        event.preventDefault();
        const newWindowReference = window.open(
            targetUrl,
            'newwindow',
            'width=1000,height=1000,noopener,noreferrer'
        );

        if (newWindowReference) {
            newWindowReference.opener = null;
        }
    };

    return (
        <div className="admin-layout-container">
            <div className="row">
                <div className="main-content">
                    <div className="content-wrapper">
                        <section className="app-page-header">
                            <div>
                                <h1 className="app-page-title">Profile</h1>
                            </div>
                            <a title="help" onClick={(e) => openWindow(e, IUrl)} className="app-help-link">
                                Help for this Page
                                <i className="pi pi-question-circle"></i>
                            </a>
                        </section>
                        <section className="content">
                            {data.map((response: any) => (
                                <div className="grid" key={response.idcard_no}>

                                    {/* LEFT PROFILE CARD */}

                                    <div className="col-12 md:col-3">
                                        <div className="card flex flex-column align-items-center p-4 border-round shadow-1 bg-white">

                                            <div className="relative mb-3">
                                                <img
                                                    src={response.photo ? response.photo : imageuser}
                                                    alt="Profile"
                                                    className="shadow-2 border-circle border-3 border-white"
                                                    style={{
                                                        width: '120px',
                                                        height: '120px',
                                                        objectFit: 'cover'
                                                    }}
                                                />
                                            </div>

                                            <h3 className="m-0 text-900 font-semibold text-xl text-center">
                                                {response.firstname}
                                            </h3>

                                            <h4 className="text-600 text-sm mt-1 text-center">
                                                {response.nameoforg}
                                            </h4>

                                            <p className="text-500 font-medium text-sm mb-4 mt-1">
                                                Organization Profile
                                            </p>

                                            <div className="w-full">
                                                <FileUpload
                                                    mode="basic"
                                                    name="fileToUpload"
                                                    customUpload
                                                    accept="image/*"
                                                    maxFileSize={1000000}
                                                    uploadHandler={UploadManagerImage}
                                                    chooseLabel="Change Photo"
                                                    className="p-button-sm p-button-outlined w-full"
                                                />
                                            </div>

                                        </div>
                                    </div>

                                    {/* RIGHT SIDE */}

                                    <div className="col-12 md:col-9">

                                        <Panel header="Personal Details" toggleable className="mb-4 shadow-1">

                                            <Card className="surface-card border-round shadow-2">

                                                <div className="grid p-fluid">

                                                    {/* LEFT COLUMN */}

                                                    <div className="col-12 md:col-6 px-4">

                                                        <div className="field grid mb-4">
                                                            <label className="col-12 text-800 font-semibold mb-2">
                                                                Name of The Organization
                                                            </label>
                                                            <div className="col-12">
                                                                <InputText
                                                                    value={nameoforg}
                                                                    data-testid='orgname-input'
                                                                    placeholder="Enter Organization Name"
                                                                    onChange={(e) => setOrgName(e.target.value)}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="field grid mb-4">
                                                            <label className="col-12 text-800 font-semibold mb-2">
                                                                Name of The Person
                                                            </label>
                                                            <div className="col-12">
                                                                <InputText
                                                                    value={nameofperson}
                                                                    data-testid='personname-input'
                                                                    placeholder="Enter Person Name"
                                                                    onChange={(e) => setPersonName(e.target.value)}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="field grid mb-4">
                                                            <label className="col-12 text-800 font-semibold mb-2">
                                                                Email Address
                                                            </label>
                                                            <div className="col-12">
                                                                <InputText
                                                                    value={email}
                                                                    data-testid='email-input'
                                                                    disabled
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="field grid mb-4">
                                                            <label className="col-12 text-800 font-semibold mb-2">
                                                                Designation
                                                            </label>
                                                            <div className="col-12">
                                                                <InputText
                                                                    value={designation}
                                                                    data-testid='designation-input'
                                                                    placeholder="Enter Designation"
                                                                    onChange={(e) => setDesignation(e.target.value)}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="field grid mb-4">
                                                            <label className="col-12 text-800 font-semibold mb-2">
                                                                Phone Number
                                                            </label>
                                                            <div className="col-12">
                                                                <InputText
                                                                    value={phone}
                                                                    data-testid='phone-input'
                                                                    placeholder="Enter Phone"
                                                                    onChange={handlePhoneChange}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="field grid mb-4">
                                                            <label className="col-12 text-800 font-semibold mb-2">
                                                                License Number
                                                            </label>
                                                            <div className="col-12">
                                                                <InputText
                                                                    value={licenseno}
                                                                    data-testid='license-input'
                                                                    placeholder="Enter License"
                                                                    onChange={(e) => setlicenseno(e.target.value)}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="field grid mb-4">
                                                            <label className="col-12 text-800 font-semibold mb-2">
                                                                Organization Type
                                                            </label>
                                                            <div className="col-12">
                                                                <Dropdown
                                                                    value={ogrtype}
                                                                    data-testid='orgtype-select'
                                                                    onChange={(e) => setOrgtype(e.value)}
                                                                    options={orgtypeOptions}
                                                                    style={{ textAlign: 'left' }}
                                                                    optionLabel="label"
                                                                    optionValue="value"
                                                                    placeholder="Select Type"
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="field grid mb-4">
                                                            <label className="col-12 text-800 font-semibold mb-2">
                                                                Website Url
                                                            </label>
                                                            <div className="col-12">
                                                                <InputText
                                                                    value={website}
                                                                    data-testid='website-input'
                                                                    placeholder="Enter Website"
                                                                    onChange={(e) => setWebsite(e.target.value)}
                                                                />
                                                            </div>
                                                        </div>
                                                        {/* Resume */}

                                                        <div className="field grid mb-4">
                                                            <label className="col-12 text-800 font-semibold mb-2">
                                                                Resume
                                                            </label>

                                                            <InputTextarea
                                                                value={resume}
                                                                data-testid='resume-textarea'
                                                                rows={6}
                                                                placeholder="Enter Resume"
                                                                onChange={(e) => setResume(e.target.value)}
                                                            />
                                                        </div>

                                                    </div>

                                                    {/* RIGHT COLUMN */}

                                                    <div className="col-12 md:col-6 px-4">

                                                        <div className="field grid mb-4">
                                                            <label className="col-12 text-800 font-semibold mb-2">
                                                                Address
                                                            </label>
                                                            <div className="col-12">
                                                                <InputText
                                                                    value={address}
                                                                    data-testid='address-input'
                                                                    placeholder="Enter Address"
                                                                    onChange={(e) => setAddress(e.target.value)}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="field grid mb-4">
                                                            <label className="col-12 text-800 font-semibold mb-2">
                                                                City
                                                            </label>
                                                            <div className="col-12">
                                                                <InputText
                                                                    value={city}
                                                                    data-testid='city-input'
                                                                    placeholder="Enter City"
                                                                    onChange={(e) => setCity(e.target.value)}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="field grid mb-4">
                                                            <label className="col-12 text-800 font-semibold mb-2">
                                                                State
                                                            </label>
                                                            <div className="col-12">
                                                                <InputText
                                                                    value={state}
                                                                    data-testid='state-input'
                                                                    placeholder="Enter State"
                                                                    onChange={(e) => setstate(e.target.value)}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="field grid mb-4">
                                                            <label className="col-12 text-800 font-semibold mb-2">
                                                                Country
                                                            </label>
                                                            <div className="col-12">
                                                                <Dropdown
                                                                    value={country}
                                                                    data-testid='country-select'
                                                                    onChange={(e) => setCountry(e.value)}
                                                                    style={{ textAlign: 'left' }}
                                                                    options={countrydata}
                                                                    optionLabel="CountryName"
                                                                    optionValue="CountryID"
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="field grid mb-4">
                                                            <label className="col-12 text-800 font-semibold mb-2">
                                                                Pincode
                                                            </label>
                                                            <div className="col-12">
                                                                <InputText
                                                                    value={pincode}
                                                                    data-testid='pincode-input'
                                                                    placeholder="Enter Pincode"
                                                                    onChange={(e) => setPincode(e.target.value)}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="field grid mb-4">
                                                            <label className="col-12 text-800 font-semibold mb-2">
                                                                License Expiry
                                                            </label>
                                                            <div className="col-12">
                                                                <InputText
                                                                    type="date"
                                                                    value={licenseexpiry}
                                                                    data-testid='expiry-input'
                                                                    onChange={(e) => setlicenseexpiry(e.target.value)}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="field grid mb-4">
                                                            <label className="col-12 text-800 font-semibold mb-2">
                                                                Organization Subtype
                                                            </label>
                                                            <div className="col-12">
                                                                <Dropdown
                                                                    value={orgsubtype}
                                                                    data-testid='subtype-select'
                                                                    onChange={(e) => setOrgsubtype(e.value)}
                                                                    style={{ textAlign: 'left' }}
                                                                    options={suborgtypeOptions}
                                                                    optionLabel="label"
                                                                    optionValue="value"
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="field grid mb-4">
                                                            <label className="col-12 text-800 font-semibold mb-2">
                                                                Paypal Account
                                                            </label>
                                                            <div className="col-12">
                                                                <InputText
                                                                    value={paypal}
                                                                    data-testid='paypal-input'
                                                                    placeholder="Enter Paypal"
                                                                    onChange={(e) => setPaypal(e.target.value)}
                                                                />
                                                            </div>
                                                        </div>

                                                    </div>

                                                </div>



                                                {/* BUTTON */}

                                                <div className="flex justify-content-end mt-4">
                                                    <Button
                                                        label="Save"
                                                        severity="info"
                                                        data-testid='save-btn'
                                                        onClick={Oprofile}
                                                    />
                                                </div>

                                            </Card>

                                            <br />

                                            {/* ATTACHMENTS */}

                                            <Panel header="Attachments" toggleable>

                                                <div className="card flex mb-3">
                                                    <span className="p-input-icon-left">
                                                        <i className="pi pi-search" />
                                                        <InputText
                                                            value={globalFilter}
                                                            onChange={(e) => setGlobalFilter(e.target.value)}
                                                            placeholder="Global Search"
                                                        />
                                                    </span>
                                                </div>

                                                <DataTable value={docdata} paginator rows={5} stripedRows>

                                                    <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No" />
                                                    <Column field="doc_name" header="Title" />
                                                    <Column field="expiry_date" header="Expiry Date" />

                                                    <Column
                                                        header="Operations"
                                                        body={(rowData, { rowIndex }) => (
                                                            <Button
                                                                icon="pi pi-eye"
                                                                severity="info"
                                                                data-testid={`view-btn-${rowIndex}`}
                                                                rounded
                                                                outlined
                                                                onClick={() => viewupload(rowData)}
                                                            />
                                                        )}
                                                    />

                                                </DataTable>

                                            </Panel>

                                        </Panel>

                                    </div>

                                </div>
                            ))}
                        </section>

                        <Dialog header="View" style={{ width: '50vw' }} visible={acceptfield} onHide={cancelfield}>
                            <div className="modal-header">
                                <Button icon="pi pi-times" className="p-button-text" />
                            </div>
                            <div className="modal-body">
                                {dataview.map((response: any, index: number) =>
                                    <div key={index}>
                                        {response.filetype === 'image' && <img src={response.displayfile} alt="Doc" width="100%" height="auto" />}
                                        {response.filetype !== 'image' &&
                                            <img src={response.displayfile} alt="Doc" width="100%" height="auto" />
                                        }
                                    </div>
                                )}
                            </div>
                        </Dialog>
                        <Toast  >
                            <Message severity="success" content={imgmessage} />
                        </Toast>


                    </div >
                </div>
            </div>
            <Toast ref={toast}>
                <Message severity="success" content={imgdata} />
            </Toast>
        </div>
    )
}

export default OrganizationProfile
